export default __webpack_public_path__ + "static/instagram-2d07a7dd2a6156c516da5fe1be9d7057.svg";